// Replaces an element's text and replays its `is-swapping` entrance animation.
// Removing the class and reading back a layout value forces the reflow CSS
// needs before the same animation will run a second time. A no-op when the
// text is unchanged, so a re-render never flashes the same value.
export default function swapText(el, text) {
  if (el.textContent === text) return

  el.classList.remove('is-swapping')
  void el.getBoundingClientRect()
  el.textContent = text
  el.classList.add('is-swapping')
}
